import React from 'react';

export default function TimeZoneExplanation() {
  const zone_string = new Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div id="timezone-explanation">
      All times are shown in <strong>{zone_string}</strong> timezone.
    </div>
  );
}
